<!-- 구성 분석 뷰 컴포넌트 -->
<template>
    <div class="org-chart-wrapper">
        <div
            class="org-chart-container"
            ref="orgChartContainer"
            @mousedown="$emit('start-drag', $event)"
            @mousemove="$emit('on-drag', $event)"
            @mouseup="$emit('stop-drag', $event)"
            @mouseleave="$emit('stop-drag', $event)"
            @wheel.prevent="$emit('handle-scroll', $event)"
            :style="zoomAndPositionStyle"
        >
            <OrgChartPanel
                ref="OrgChartPanel"
                v-if="energyMap"
                :data="energyMap"
                :queryType="queryType"
                :statusDate="statusDate"
                @open-point-detail="$emit('open-point-detail', $event)"
                @close-point-detail="$emit('close-point-detail', $event)"
            />
        </div>
        <!-- 줌 컨트롤 버튼 -->
        <div class="zoom-controls">
            <button @click="$emit('reset-zoom')" class="zoom-reset" ref="zoomResetButton">
                <i class="fas fa-redo" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</template>

<script>
import OrgChartPanel from "../../panel/OrgChartPanel.vue";

export default {
    name: "OrgChartView",
    components: {
        OrgChartPanel,
    },
    props: {
        energyMap: {
            type: Array,
            default: null,
        },
        queryType: {
            type: String,
            default: "NOW",
        },
        statusDate: {
            type: String,
            required: true,
        },
        zoomAndPositionStyle: {
            type: Object,
            required: true,
        },
    },
    emits: [
        "start-drag",
        "on-drag",
        "stop-drag",
        "handle-scroll",
        "reset-zoom",
        "open-point-detail",
        "close-point-detail",
    ],
    methods: {
        getOrgChartPanel() {
            return this.$refs.OrgChartPanel;
        },
    },
};
</script>

<style lang="scss" scoped>
.org-chart-wrapper {
    position: relative;
    height: 50rem;
    overflow: hidden;
}

.org-chart-container {
    width: 100%;
    height: 100%;
    position: relative;
    cursor: grab;
}

.org-chart-container:active {
    cursor: grabbing;
}

.zoom-controls {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    gap: 10px;
}

.zoom-controls button {
    padding: 5px 10px;
    font-size: 16px;
    cursor: pointer;
}
</style>
